import Position from './Position'
import PositionLevel from './PositionLevel'
import PositionType from './PositionType'
import PositionImport from './PositionImport'
import AppPrivacy from './AppPrivacy'

export default {
  Position,
  PositionLevel,
  PositionType,
  PositionImport,
  AppPrivacy
}



// WEBPACK FOOTER //
// ./src/components/HRM/Pos/index.js